import Contact from "../../blocks/contact/scripts"
import DoubleImage from "../../blocks/double-image/scripts"
import SliderBrand from "../../blocks/slider-brand/scripts"
import Button from "../../blocks/button/scripts"
import Hero from "../../blocks/hero/scripts"
import Testimonials from "../../blocks/testimonials/scripts"
import SliderDouble from "../../blocks/slider-double/scripts"
import ImgLink from "../../blocks/img-link/scripts"
import MasonryGrid from "../../blocks/masonry-grid/scripts"
import SliderTeam from "../../blocks/slider-team/scripts"
import Blog from "../../blocks/blog/scripts"
import Header from "../../blocks/header/scripts"
import SliderImg from "../../blocks/slider-img/scripts"
import TextImg from "../../blocks/text-img/scripts"
import ArticleBlog from "../../blocks/article-blog/scripts"
import "../../blocks/title-text/scripts"
import "../../blocks/triple-image/scripts"
import Lenis from 'lenis'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Swup from 'swup'
import initReveal from './reveal'
import { setupPageTransition } from './page-transition'

let headerInstance = null

function initLenis() {
  if (window.lenis) {
    window.lenis.destroy()
  }
  window.lenis = new Lenis({
    autoRaf: true,
    lerp: 0.06,
    easing: 'ease-in-out',
    wheelMultiplier: 0.7
  })
  // Force la position à 0 sans easing pour éviter tout report de scroll après navigation
  window.lenis.scrollTo(0, { immediate: true, force: true })
}

function initHeader() {
  const el = document.querySelector('.header')
  if (!el) return
  if (!headerInstance) {
    headerInstance = new Header(el)
  } else {
    headerInstance.initColorPrimary()
  }
}

function initBlocks() {
  document.querySelectorAll('.contact').forEach(el => new Contact(el))
  document.querySelectorAll('.double-image').forEach(el => new DoubleImage(el))
  document.querySelectorAll('.btn').forEach(el => new Button(el))
  document.querySelectorAll('.hero').forEach(el => new Hero(el))
  document.querySelectorAll('.slider-brand').forEach(el => new SliderBrand(el))
  document.querySelectorAll('.testimonials').forEach(el => new Testimonials(el))
  document.querySelectorAll('.slider-double').forEach(el => new SliderDouble(el))
  document.querySelectorAll('.img-link').forEach(el => new ImgLink(el))
  document.querySelectorAll('.masonry-grid').forEach(el => new MasonryGrid(el))
  document.querySelectorAll('.slider-team').forEach(el => new SliderTeam(el))
  document.querySelectorAll('.blog').forEach(el => new Blog(el))
  document.querySelectorAll('.slider-img').forEach(el => new SliderImg(el))
  document.querySelectorAll('.text-img').forEach(el => new TextImg(el))
  document.querySelectorAll('.article-blog').forEach(el => new ArticleBlog(el))

  initReveal()

  // Recalcule les triggers une fois Lenis prêt et le DOM stabilisé
  requestAnimationFrame(() => ScrollTrigger.refresh())
}

function cleanupBlocks() {
  ScrollTrigger.getAll().forEach(st => st.kill())
}

document.addEventListener('DOMContentLoaded', () => {
  // Empêche le navigateur de restaurer la position de scroll précédente lors des transitions Swup
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual'
  }

  initLenis()
  initHeader()
  initBlocks()

  const swup = new Swup({
    containers: ['#swup'],
    animationSelector: false,
    linkSelector: 'a[href]:not([data-no-swup]):not([href^="#"]):not([href^="mailto:"]):not([href^="tel:"]):not([target="_blank"])'
  })

  setupPageTransition(swup, {
    onBeforeLeave: cleanupBlocks,
    onContentReplaced: () => {
      initLenis()
      initHeader()
      initBlocks()
    }
  })
})
